// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2qy5L","errorLogs":"EditorFooter_errorLogs__p96cq"};